const config = {
  STYTCH_DISCOVERY_REDIRECT_URL: import.meta.env.VITE_STYTCH_DISCOVERY_REDIRECT_URL || '',
  STYTCH_SESSION_DURATION_MINUTES: parseInt(
    import.meta.env.VITE_STYTCH_SESSION_DURATION_MINUTES || '1440',
    10,
  ),
  EVENT_COLLECTOR_URL: import.meta.env.VITE_EVENT_COLLECTOR_URL || '',
  MARKETTI_URL: import.meta.env.VITE_MARKETTI_URL || '',
  TRANSLATE_URL: import.meta.env.VITE_TRANSLATE_URL || '',
  HUUVA_URL: import.meta.env.VITE_WEBHOOK_URL || '',
  HELLA_URL: import.meta.env.VITE_HELLA_URL || '',
  TARJOILIJA_URL: import.meta.env.VITE_TARJOILIJA_URL || '',
  JULISTE_URL: import.meta.env.VITE_JULISTE_URL || '',
  TUKKU_URL: import.meta.env.VITE_TUKKU_URL || '',
  PUBLISHING_URL: import.meta.env.VITE_PUBLISHING_URL || '',
  CAMPAIGNS_URL: import.meta.env.VITE_CAMPAIGNS_URL || '',

  APP_ENV: import.meta.env.VITE_APP_ENV || 'production',
  SERVICE_DOMAIN: import.meta.env.VITE_SERVICE_DOMAIN || '',
  SENTRY_DSN: import.meta.env.VITE_SENTRY_DSN || '',
  SENTRY_DEBUG: import.meta.env.VITE_SENTRY_DEBUG === 'true',
  SENTRY_TRACING_SAMPLE_RATE: import.meta.env.VITE_SENTRY_TRACING_SAMPLE_RATE
    ? parseFloat(import.meta.env.VITE_SENTRY_TRACING_SAMPLE_RATE)
    : undefined,
  SENTRY_REPLAYS_SESSION_SAMPLE_RATE: import.meta.env.VITE_SENTRY_REPLAYS_SESSION_SAMPLE_RATE
    ? parseFloat(import.meta.env.VITE_SENTRY_REPLAYS_SESSION_SAMPLE_RATE)
    : undefined,
  SENTRY_REPLAYS_ON_ERROR_SAMPLE_RATE: import.meta.env.VITE_SENTRY_REPLAYS_ON_ERROR_SAMPLE_RATE
    ? parseFloat(import.meta.env.VITE_SENTRY_REPLAYS_ON_ERROR_SAMPLE_RATE)
    : undefined,
  LOG_FORMAT: import.meta.env.VITE_LOG_FORMAT || 'json',
  LOG_LEVEL: import.meta.env.VITE_LOG_LEVEL || 'info',
  REMOTE_LOGGING_TOPIC: import.meta.env.VITE_REMOTE_LOGGING_TOPIC || '',
  STYTCH_PUBLIC_TOKEN: import.meta.env.VITE_STYTCH_PUBLIC_TOKEN || '',
  PANNU_EVENTS_TOPIC: import.meta.env.VITE_PANNU_EVENTS_TOPIC || '',
  PANNU_EVENTS_NOTIFICATIONS_TOPIC: import.meta.env.VITE_PANNU_EVENTS_NOTIFICATIONS_TOPIC || '',
  SOCKET_PATH: import.meta.env.VITE_SOCKET_PATH || '',
};

export default config;
